import * as React from 'react';
import GamePageLayout from '../../../components/GamePageLayout';
import GameNavbar from "../../../components/GameNavbar";
import GameHeader from "../../../components/GameHeader";
import appService from '../../../Service'
import {Button,Util} from "baziigram";
import './styles.css'
import {useEffect, useState} from "react";
import  {STORAGE_KEY,dictionary} from "../../../constants";
import gameanalytics from "gameanalytics";
import {useDispatch, useSelector} from "react-redux";
import {persist} from "../../../redux/actions";
import {LEADERBOARD_ACTION_PERSIST , LEADERBOARD_ACTION_CLEAR} from "../../../redux/Leaderboard/leaderboard.constant.js"

const LeaderboardPage = (props) => {

const { gameId , language , items , serverError , className} = useSelector(state => state.leaderboard);


  const dispatch = useDispatch();
  const updateState=(state)=>{
    dispatch(persist(state, LEADERBOARD_ACTION_PERSIST))

  }

    React.useEffect(()=>{
    if(props.location.state && props.location.state.gameId)
          updateState({gameId:props.location.state.gameId})

    if(gameId)
       loadItems()

    },[gameId])

        React.useEffect(()=>{
        let l = Util.getLanguage()
        updateState({language:l , className:l=="fa"?"rtl text-right" : "ltr text-left"})
         },[])

    useEffect(()=>{
        if(typeof window !== `undefined`) {
            var gameanalytics = require('gameanalytics');
            gameanalytics.GameAnalytics.initialize("712c556d47699b5e1d7beb4e004716cc",
                "7838a8d082e4769dc7ddf99ea1f07fd3ab83322a");
            let user = JSON.parse(Util.Storage.get(STORAGE_KEY.GAME_USER))
            gameanalytics.GameAnalytics.addDesignEvent("leadeboard", 3, user);
        }
    },[])

    const loadItems=()=>{
        updateState({serverError:null})
        appService.GetLeaderboard(gameId).then(res=>{
            updateState({items:res.list})

        }).catch(err=>{
            updateState({serverError:dictionary.retryText[language]})
        })
    }



    const scrollToNews = ()=>{
        document.getElementById('leaderboard').scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
    }



    return (
        <GamePageLayout type={LEADERBOARD_ACTION_CLEAR}>
            <GameNavbar backUrl={"/Game/LifeStone"}/>
            <div className={"rtl"}>
                <GameHeader >

                        <div className={"text_header text-center d-flex flex-column justify-content-center align-items-center"}>
                           <div dangerouslySetInnerHTML={{__html: dictionary.leaderboardHeader[language]}} />

                            <Button className={"mt-3"} onClick={scrollToNews} title={dictionary.seeHeroes[language]}></Button>

                        </div>

                </GameHeader>



                <div id={"leaderboard"} className='main_container'>

                    {items==null && serverError==null && <div
                        className={`baziigram-spinner mt-5 spinner-border text-light m-auto`}
                        role="status"
                    ></div>}
                    {serverError && <div className={"text-center text-warning "}>
                        {serverError}
                        <Button onClick={loadItems} className={"mt-3"} title={dictionary.retry[language]}/>
                    </div>}
                    {items != null && serverError==null && <>


                        <div className="grid-container rtl">
                            <div
                                className={`row align-items-start justify-content-center`}
                                style={{  paddingTop: '50px' }}
                            >
                                {
                                    items && items.map((item,i)=>{
                                        return <div   className=" col-12   my-4">
                                            <div className={`leaderboardItem ${i==0?'leaderboardFirstItem'
                                                :(i==1?'leaderboardSecondItem'
                                                    :(i==2?'leaderboardThirdItem':''))}
                                             d-flex flex-row align-items-center justify-content-between rtl`}>
                                                <img alt={"player"} className={"leaderboard-item-logo mx-2"} src={`/images/profileImages/${item.logo}.png`}/>
                                                <div style={{maxWidth:"50%" , overflow:"hidden"}} className={"text-center mx-2"}>{item.name}</div>
                                                    <div className={"text-center mx-2"}> {dictionary.level[language]}: {item.level}</div>

                                            </div>

                                        </div>
                                    })
                                }

                            </div>

                        </div>
                    </>}



                </div>


            </div>

        </GamePageLayout>
    )
}

export default LeaderboardPage;
